export default {
      id: "icon--speak-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "./../Views/Shared/_SvgSprite.cshtml#icon--speak",
      toString: function () {
        return this.url;
      }
    }